import { useRef } from "react";
import { Camera, Upload, X } from "lucide-react";

export default function PhotoPicker({ preview, onSelectFile, onClear }) {
  const fileRef = useRef(null);
  const cameraRef = useRef(null);

  const handleChange = (e) => onSelectFile(e.target.files?.[0]);

  return (
    <div>
      <label className="ws-label">Step 01 · Your Photo</label>
      <div className="mt-3 border-2 border-[#09090B] bg-white ws-hard-shadow">
        {preview ? (
          <div className="relative">
            <img src={preview} alt="Preview" className="w-full max-h-[500px] object-contain bg-[#F4F4F5]" />
            <button
              type="button"
              onClick={onClear}
              data-testid="remove-photo-btn"
              className="absolute top-3 right-3 bg-[#09090B] text-white w-10 h-10 flex items-center justify-center hover:bg-[#FF5A00] transition-colors"
            >
              <X strokeWidth={2.5} className="w-5 h-5" />
            </button>
          </div>
        ) : (
          <div className="p-8 grid sm:grid-cols-2 gap-4">
            <button
              type="button"
              onClick={() => cameraRef.current?.click()}
              data-testid="open-camera-btn"
              className="flex flex-col items-center justify-center gap-3 bg-[#FF5A00] text-white py-8 px-4 hover:bg-[#E65100] transition-colors border-2 border-[#09090B]"
            >
              <Camera strokeWidth={2.5} className="w-10 h-10" />
              <div className="ws-label">Use Camera</div>
            </button>
            <button
              type="button"
              onClick={() => fileRef.current?.click()}
              data-testid="upload-photo-btn"
              className="flex flex-col items-center justify-center gap-3 bg-white text-[#09090B] py-8 px-4 hover:bg-[#F4F4F5] transition-colors border-2 border-[#09090B]"
            >
              <Upload strokeWidth={2.5} className="w-10 h-10" />
              <div className="ws-label">Upload File</div>
            </button>
          </div>
        )}
        <input
          ref={cameraRef}
          type="file"
          accept="image/*"
          capture="environment"
          className="hidden"
          onChange={handleChange}
        />
        <input
          ref={fileRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={handleChange}
        />
      </div>
    </div>
  );
}
